import { type PlacementBrowserConfig } from '@post-office/message-maker-browser/types';

import { createPlacementBackend } from '@post-office/message-maker-node/placements/create-placement-backend';

import { type PlacementMessageBackendFactory } from '@post-office/message-maker-node/placements/types';

import { createDefaultPlacementMiddleware } from '@post-office/message-maker-node/placements/middleware';

import type { AnyPayload } from '@post-office/message-template-contracts/placement-v2';

import {
	type BackendSyncMessageStage,
	type AnyBackendMessageStage,
} from '@post-office/message-maker-node/placements/types';

import { type TransformMetadataResult } from '@post-office/shared-contracts/message-template-metadata';

import { runConfluenceSideNavPlacement } from './run-confluence-side-nav-placement';

const placementConfig: PlacementBrowserConfig = {
	placementId: 'confluence-side-nav',
	options: {
		choreographer: {
			isDefaultEnabled: false,
		},
	},
};

const createBackend = createPlacementBackend(placementConfig);

export const PlacementBackend: PlacementMessageBackendFactory<{
	transformMetadata: BackendSyncMessageStage<AnyPayload, TransformMetadataResult>;
	hydrate?: AnyBackendMessageStage;
}> = createBackend({
	customMiddleware: createDefaultPlacementMiddleware(runConfluenceSideNavPlacement),
});
